// ════════════════════════════════════════════════════════════════
// legalWriteService — Thin client for the `legal-write` edge function.
// Frontend code MUST go through this; never write directly to the DB.
// ════════════════════════════════════════════════════════════════

import { supabase } from '@/integrations/supabase/client';
import type { LegalDocumentType } from './types';

async function invoke<T = unknown>(body: Record<string, unknown>): Promise<T> {
  const { data, error } = await supabase.functions.invoke('legal-write', { body });
  if (error) throw new Error(error.message);
  if (data && typeof data === 'object' && 'error' in data && data.error) {
    throw new Error(String((data as { error: unknown }).error));
  }
  return data as T;
}

export function createLegalDocument(input: {
  type: LegalDocumentType;
  title: string;
  slug: string;
}) {
  return invoke({ command: 'create_legal_document', payload: input });
}

export function createLegalVersion(input: {
  document_type: LegalDocumentType;
  content_md: string;
  content_html?: string | null;
}) {
  return invoke({ command: 'create_legal_version', payload: input });
}

export function publishLegalVersion(input: {
  document_type: LegalDocumentType;
  version: number;
}) {
  return invoke({ command: 'publish_legal_version', payload: input });
}

export function acceptLegal(input: {
  document_type: LegalDocumentType;
  version: number;
}) {
  return invoke({ command: 'accept_legal', payload: input });
}